<template>
  <v-footer inset class="white" elevation="6" app>
    <v-container
      grid-list-md
      :style="$vuetify.breakpoint.xl ? 'max-width: 70%' : $vuetify.breakpoint.xs ? 'max-width: 100%; padding: 0 8px;' : $vuetify.breakpoint.smAndDown ? 'max-width: 95%' : ''"
    >
      <v-layout wrap align-center>
        <v-flex md5 :class="compacto ? 'xs12' : 'xs6'" class="white text-left">
          <span class="p12">
            <strong>
              <a target="_blank" class="estilo-link-site" href="http://espacomossoo.com.br">Espaço Mossoo &copy;</a>
            </strong>
            {{ versao }} - Alfredo Wagner - Santa Catarina - Brasil
          </span>
        </v-flex>

        <v-flex xs1 v-if="!compacto" class="justify-center">
          <v-img :style="`position: absolute; bottom: 20px; opacity: 0.7;`" class="img-responsive" src="folha.png" :max-width="$vuetify.breakpoint.smAndDown ? 80 : 120"></v-img>
        </v-flex>

        <v-spacer v-if="!compacto"></v-spacer>

        <v-flex
          md3
          :class="compacto ? 'xs12' : 'xs5'"
          :style="$vuetify.breakpoint.xs ? 'justify-content: center;' : 'justify-content: flex-end;'"
          class="white"
          style="display: flex; align-items: center; gap: 6px; flex-wrap: nowrap"
        >
          <a href="https://cadastur.turismo.gov.br" target="_blank" :style="`margin-right: ${marginCadastur}px;`"
            ><img src="cadastur.jpeg" :style="`height: ${$vuetify.breakpoint.smAndDown ? '22px' : '30px'}; opacity: 0.85;`" title="Cadastur"
          /></a>
          <a href="https://www.atuvivaw.com.br" target="_blank" :style="`margin-right: ${marginAtuviva}px;`"
            ><img src="atuvivaw.jpeg" :style="`height: ${$vuetify.breakpoint.smAndDown ? '22px' : '30px'}; opacity: 0.85;`" title="AtuViva"
          /></a>

          <v-btn icon href="mailto:mossooespaco@gmail.com">
            <v-icon title="Email" color="#5b361b">mail</v-icon>
          </v-btn>

          <v-btn
            icon
            href="https://www.google.com/maps/place/Espa%C3%A7o+Mossoo/data=!4m10!3m9!1s0x95207fef08845b97:0xd345f0a49db772e8!5m2!4m1!1i2!8m2!3d-27.6412178!4d-49.4322286!16s%2Fg%2F11st8bkb7d!19sChIJl1uECO9_IJUR6HK3naTwRdM?authuser=0&hl=pt-BR&rclk=1"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Abrir Espaço Mossoo no Google Maps"
          >
            <v-icon title="Google Maps" color="#4285F4">mdi-google-maps</v-icon>
          </v-btn>

          <v-btn icon href="https://www.facebook.com/espacomossoo" target="_blank">
            <v-icon title="Facebook" color="#3b5998">mdi-facebook</v-icon>
          </v-btn>

          <v-btn icon href="https://www.instagram.com/espacomossoo/" target="_blank">
            <v-icon title="Instagram" color="#517fa4">mdi-instagram</v-icon>
          </v-btn>

          <v-btn icon href="https://br.pinterest.com/mossooespaco/" target="_blank">
            <v-icon title="Pinterest" color="#E60023">mdi-pinterest</v-icon>
          </v-btn>

          <v-btn icon href="https://api.whatsapp.com/send/?phone=+5548999823931&text&type=phone_number&app_absent=0&text=Olá Espaço Mossoo..." target="_blank">
            <v-icon title="Whatsapp" color="#34af23">mdi-whatsapp</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      versao: ""
    };
  },
  computed: {
    compacto() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    marginCadastur() {
      if (this.$vuetify.breakpoint.xl) return 24;
      if (this.$vuetify.breakpoint.lgOnly) return 16;
      if (this.$vuetify.breakpoint.mdOnly) return 10;
      return 2;
    },
    marginAtuviva() {
      if (this.$vuetify.breakpoint.xl) return 48;
      if (this.$vuetify.breakpoint.lgOnly) return 32;
      if (this.$vuetify.breakpoint.mdOnly) return 20;
      return 4;
    }
  },
  async created() {
    try {
      this.versao = process.env.VUE_APP_VERSAO;
    } catch {}
  }
};
</script>
